import { createAction, handleActions } from 'redux-actions';
import { api } from "api";
import { initialize as initializeForm } from "redux-form";
import { NotificationManager } from "react-notifications";
import { push } from "react-router-redux";

const LOADER = 'LOADER_SUCURSALES';
const DATA = 'DATA_SUCURSALES';
const ITEM_DATA = 'ITEM_SUCURSALES';
const PAGE = 'PAGE_SUCURSALES';
const ORDERING = 'ORDERING_SUCURSALES';
const SEARCH = 'SEARCH_SUCURSALES';

// -----------------------------------
// Pure Actions
// -----------------------------------

const setLoader = loader => ({
    type: LOADER,
    loader,
});

const setData = data => ({
    type: DATA,
    data,
});

const setItem = item => ({
    type: ITEM_DATA,
    item,
});

const setPage = page => ({
    type: PAGE,
    page,
});

const setOrdering = ordering => ({
    type: ORDERING,
    ordering,
});

const setSearch = search => ({
    type: SEARCH,
    search,
});

// ------------------------------------
// Actions
// ------------------------------------
const crear = data => (dispatch) => {
    dispatch(setLoader(true));
    api.post('garage_branches', data).then(() => {
        NotificationManager.success('Registro creado', 'Éxito', 3000);
        dispatch(cleanForm()); // Limpiar el formulario
        dispatch(push(`/garage/${data.garage}/branches`));
    }).catch((error) => {
        let mensaje = 'Error en la creación, vuelve a intentarlo';
        if (error) {
            if (error.detail)
                mensaje = error.detail;
        }
        NotificationManager.error(mensaje, 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const leer = (id, idGarage = 0) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${'garage_branches'}/${(id)}`).then((response) => {
        if (idGarage != response.garage) {
            return <Redirect to={`"/`} />;
        }
        dispatch(setItem(response));
        dispatch(initializeForm('SucursalForm', response));
    }).catch(() => {
        dispatch(push('/'));
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


const listar = (page = 1, idGarage = 0) => (dispatch, getStore) => {
    const resource = getStore().sucursales;
    const params = { page, garage_id: idGarage };

    if (resource.ordering)
        params.ordering = resource.ordering;
    if (resource.search)
        params.search = resource.search;

    dispatch(setLoader(true));
    api.get('garage_branches', params).then((response) => {
        dispatch(setData(response));
        dispatch(setPage(page));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const editar = (id, data) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`garage_branches/${id}`, data)
        .then(() => {
            NotificationManager.success('Registro actualizado', 'Éxito', 3000);
            dispatch(push(`/garage/${data.garage}/branches`));
        })
        .catch((error) => {
            let mensaje = 'Error en la edición, vuelve a intentarlo';
            if (error) {
                if (error.detail)
                    mensaje = error.detail;
            }
            NotificationManager.error(mensaje, 'ERROR', 3000);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};


const eliminar = (id, idGarage) => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`garage_branches/${id}`).then(() => {
        dispatch(listar(1, idGarage));
        NotificationManager.success('Registro eliminado', 'Éxito', 3000);
    }).catch(() => {
        let mensaje = 'Error en la eliminación, vuelve a intentarlo';
        if (error) {
            if (error.detail)
                mensaje = error.detail;
        }
        NotificationManager.error(mensaje, 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};
const aprobar_sucursal = (id, idGarage) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`garage_branches/${id}`, { approved_branch: true }).then(() => {
        dispatch(listar(1, idGarage));
        NotificationManager.success('Sucursal aprobado correctamente', 'Éxito', 3000);
    }).catch(() => {
        let mensaje = 'Error al aprobar, vuelve a intentarlo';
        if (error) {
            if (error.detail)
                mensaje = error.detail;
        }
        NotificationManager.error(mensaje, 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


const cleanForm = () => (dispatch) => {
    dispatch(initializeForm('SucursalForm', {}));
};

const searchChange = (search, idGarage) => (dispatch, getStore) => {
    dispatch(setSearch(search));
    dispatch(listar(1, idGarage));
};

const onSortChange = (ordering, idGarage) => (dispatch, getStore) => {
    const sort = getStore().sucursales.ordering;
    if (ordering === sort) {
        dispatch(setOrdering(`-${ordering}`));
    } else {
        dispatch(setOrdering(ordering));
    }
    dispatch(listar(1, idGarage));
};

export const actions = {
    listar,
    leer,
    crear,
    editar,
    eliminar,
    searchChange,
    onSortChange,
    cleanForm,
    aprobar_sucursal,
};

// ------------------------------------
// Reducers
// ------------------------------------

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [ITEM_DATA]: (state, { item }) => {
        return {
            ...state,
            item,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [ORDERING]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [SEARCH]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },
};

export const initialState = {
    loader: false,
    data: {
        results: [],
        count: 0,
    },
    item: {},
    page: 1,
    ordering: '',
    search: '',
};

export default handleActions(reducers, initialState);
